import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from '../../environments/environment';

import { Pelicula } from '../models/pelicula';
import { PeliculaService } from '../services/pelicula.service';

import { ProgramacionService } from '../services/programacion.service';

@Component({
  selector: 'app-peliculas',
  templateUrl: './peliculas.component.html',
  styleUrls: ['./peliculas.component.css']
})
export class PeliculasComponent implements OnInit {


  models: Pelicula[];

  model: Pelicula = new Pelicula();

  filtro: FormGroup;
  url = environment.imgUrl;
  p;
  constructor(private modelService: PeliculaService, private programacionService: ProgramacionService, private formBuilder: FormBuilder) {
    this.models = [];
  }

  ngOnInit() {

    this.onSubmit();
  }

  onSubmit() {

    let filter = {
    }
    this.modelService.getFilter(filter).subscribe(val => {
      this.models = val;
    });

    let filter2 = {
      "destacado": 1
    }


    this.modelService.getFilter(filter2).subscribe(val => {
      this.model = val[0];
      if (this.model == null || this.model == undefined) {
        this.model = new Pelicula();
        this.model.imagen_horizontal = null
      }
    });
    // this.programacionService.getFilter(filter2).subscribe(val => {
    //   this.model = val[0].destacada;
    // });

  }


}
